module.exports = __webpack_public_path__ + "img/sankaku_15_red.4a2de136.png";